<template>
  <div class="shadow-lg rounded-xl border-t-4 border-line bg-white">
    <div class="flex justify-center">
      <img src="@/assets/default/images/logo-LINE_PAY.svg" />
    </div>
    <div class="rounded-xl overflow-hidden relative">
      <div class="inner-frame pointer-events-none" />
      <div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LinePayDialogFrame',
});
</script>

<style scoped lang="scss">
.inner-frame {
  position: absolute;
  box-shadow: inset 0px 4px 18px rgba(0, 0, 0, 0.25);
  left: -50px;
  right: -50px;
  bottom: -50px;
  top: 0;
}
</style>
